<template>
  <v-card class="mt-3 elevation-0">
    <v-card-title>
      <h5>Pareto Reclamação por Subestação</h5>
    </v-card-title>
    <v-card-text class="pa-2">
      <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
    </v-card-text>
  </v-card>
</template>

<script>
  import Highcharts from "highcharts";
  import HighchartsNoData from "highcharts/modules/no-data-to-display";
  HighchartsNoData(Highcharts);

  export default {
    name: "ChartParetoReclamacaoSubestacaoTecnicos",
    props: {
      subestacoes: {
        type: Array,
        required: true,
      },
      dados: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      chartOptions: {},
    }),
    created() {
      this.setChartOptions();
    },
    methods: {
      setChartOptions() {
        this.chartOptions = {
          chart: {
            type: "column",
            zoomType: "x",
            height: 300,
          },
          credits: { enabled: false },
          title: { text: null },
          subtitle: { text: null },
          xAxis: {
            categories: this.subestacoes,
            crosshair: true,
            title: { text: "Subestação" },
          },
          yAxis: {
            title: { text: null },
          },
          plotOptions: {
            series: {
              animation: false,
              boostThreshold: 1500,
              turboThreshold: 10000,
            },
          },
          lang: {
            noData: "Sem dados para exibição",
          },
          series: [this.getChartSerie(this.dados, "Reclamação")],
        };
      },
      getChartSerie(dados, serieName) {
        return {
          name: serieName,
          animation: false,
          data: this.subestacoes
            .map((category) => {
              return category in dados
                ? {
                    x: this.subestacoes.indexOf(category),
                    y: Number(dados[category]),
                  }
                : { x: this.subestacoes.indexOf(category), y: null };
            })
            .filter((val) => val !== null && val.y !== null && val.y > 0),
        };
      },
    },
    watch: {
      subestacoes() {
        this.setChartOptions();
      },
    },
  };
</script>

<style></style>
